module.exports = __webpack_public_path__ + "static/media/img-children.cf015f0d.jpg";